import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import getSiteInvoicePreview, {
  InvoicePreviewResponse,
} from "../http/getSiteInvoicePreview";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

interface UseSiteInvoicePreviewParams {
  siteId: string;
  month: string;
  enabled?: boolean;
}

export const useSiteInvoicePreview = ({
  siteId,
  month,
  enabled,
}: UseSiteInvoicePreviewParams) => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const fetchInvoicePreview: UseQueryResult<InvoicePreviewResponse, unknown> =
    useQuery(
      ["site", siteId, "invoice_preview", month],
      async () => {
        return getSiteInvoicePreview(
          await getAuthTokenBlocking(getToken, relogin),
          siteId,
          month
        );
      },
      {
        enabled: (enabled ?? true) && !!month,
        staleTime: 5 * 60 * 1000,
      }
    );

  return {
    fetchInvoicePreview,
  };
};
